import styles from "./index.module.css"
import { WarningOutlined } from "@ant-design/icons"

const WarningOutlinedWithBg = () => {
  return <WarningOutlined className={styles.warningIcon} />
}

export default WarningOutlinedWithBg
